import React from "react";

const CPCFormat = ({ cpc = 0, country = "US" }) => {
  const nFormatter = (num, country) => {
    const currencyMap = {
      US: "$",
      GB: "£",
      CA: "$",
      JP: "¥",
      FR: "€",
      AU: "$",
      IN: "₹",
      IE: "€",
      TR: "₺",
      BE: "€",
      GR: "€",
      MX: "$",
      DK: "Kr.",
      AR: "$",
      CH: "¥",
      ES: "€",
    };
    return `${num}${currencyMap[country]}`;
  };

  return <>{nFormatter(cpc, country)}</>;
};

export default CPCFormat;
